import { useState } from "react";
import { saveJobBoardByJobID } from "services";

const useSaveJobBoardByJobID = (jobID) => {
  const [isLoading, setIsLoading] = useState(false);
  const [response, setResponse] = useState();

  const saveJobBoard = async (payload) => {
    setIsLoading(true);

    const response = await saveJobBoardByJobID(jobID, payload);

    setResponse(response);

    setIsLoading(false);
  };

  return { saveJobBoard, isLoading, response };
};

export { useSaveJobBoardByJobID };
